// Module
var code = "<div class=\"question-choice\" ng-class=\"selectedClass()\" ng-click=\"selection()\"><span>{{value}}</span></div>";
// Exports
module.exports = code;